import React from 'react'
import { useCustomFields } from 'context/customFields'
import { CustomFieldFormField } from 'components/CustomFields/CustomFieldsColumn/CustomFieldsFormColumn/CustomFieldFormField'

export function CustomFieldsFormColumn ({ section, disabled }) {
  const { customFields, entityId } = useCustomFields()

  return (
    <>
      {customFields && section && customFields[section.value]?.map(fieldDefinition =>
        <CustomFieldFormField
          key={fieldDefinition.id}
          entityId={entityId}
          definition={fieldDefinition}
          disabled={disabled}/>
      )}
    </>
  )
}